import { useCallback } from "react";
import { useSetAtom, useAtomValue } from "jotai";
import {
  isDefaultFilter,
  filterInfoAtom,
  setFilterAtom,
  clearFilterAtom,
  isFilterAppliedAtom,
  setIsFilterAppliedAtom,
  quickFilterInfoAtom,
  setQuickFilterAtom,
  setAnalystFilterFieldAtom,
  FilterInfo,
} from "@/store/deduction/deductionFilter";
import { getRemittancesAtom, setCurrentPageAtom as setRemittanceCurrentPageAtom } from "@/store/deduction/remittance";
import { getRemittanceItemsAtom, setCurrentPageAtom as setRemittanceItemCurrentPageAtom } from "@/store/deduction/remittanceItem";
import { useWorkspace } from "@/hooks";
import { AppConfig } from "@/infrastructure/services/config";
import { ApprovalFilterInfo } from "@/store/approvals";
import { AnalyticsFilterInfo } from "@/store/analytics";

export function useDeductionFilter() {
  const { settings } = useWorkspace();

  const filterInfo = useAtomValue(filterInfoAtom);
  const quickFilterInfo = useAtomValue(quickFilterInfoAtom);

  const isFilterApplied = useAtomValue(isFilterAppliedAtom);


  const setFilter = useSetAtom(setFilterAtom);
  const setQuickFilter = useSetAtom(setQuickFilterAtom);
  const setAnalystFilterField = useSetAtom(setAnalystFilterFieldAtom);
  const clearFilter = useSetAtom(clearFilterAtom);

  const setIsFilterApplied = useSetAtom(setIsFilterAppliedAtom);
  const setRemittanceCurrentPage = useSetAtom(setRemittanceCurrentPageAtom);
  const setRemittanceItemCurrentPage = useSetAtom(setRemittanceItemCurrentPageAtom);
  const getRemittances = useSetAtom(getRemittancesAtom);
  const getRemittanceItems = useSetAtom(getRemittanceItemsAtom);

  const defaultCheckDateRangeInMonths = settings?.defaultFilterCheckDateRange ?? AppConfig.getInstance().DEFAULT_FILTER_CHECK_DATE_RANGE;

  const isDefaultFilterWithSettings = useCallback(
    (info: FilterInfo | ApprovalFilterInfo | AnalyticsFilterInfo) => isDefaultFilter(info, defaultCheckDateRangeInMonths),
    [defaultCheckDateRangeInMonths]
  );

  return {
    filterInfo,
    quickFilterInfo,
    isFilterApplied,
    isDefaultFilter: isDefaultFilterWithSettings,
    setFilter,
    setQuickFilter,
    setAnalystFilterField,
    clearFilter,
    setIsFilterApplied,
    setRemittanceCurrentPage,
    setRemittanceItemCurrentPage,
    getRemittances,
    getRemittanceItems,
  };
}
